import React, { useEffect, useRef, useState } from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

import Pagination from "@mui/material/Pagination";

import "swiper/css";
import "swiper/css/pagination";
import {
  fetchNewsletter,
  NewsletterData,
  NewsletterDoc,
} from "components/Service/newsLetterApi";
import TypedText from "components/Homes/typewrite";
import Breadcrumb from "components/Breadcrumb";

/* ================= HELPERS ================= */

// const chunkArrays = (arr: NewsletterDoc[], size: number) =>
//   Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
//     arr.slice(i * size, i * size + size),
//   );
// const chunkArray = (array: any[], size: number) => {
//   const result = [];
//   for (let i = 0; i < array.length; i += size) {
//     result.push(array.slice(i, i + size));
//   }
//   return result;
// };

/* ================= COMPONENT ================= */

const NewsletterAbout = () => {
  const [data, setData] = useState<NewsletterData | null>(null);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    fetchNewsletter()
      .then(setData)
      .catch((err) => console.error("Failed to fetch newsletter:", err));
  }, []);

const carouselRef = useRef<HTMLDivElement | null>(null);
const [currentSlide, setCurrentSlide] = useState(1);

useEffect(() => {
  const el = carouselRef.current;

  if (!el) return;

  const handleSlide = (e: any) => {
    setCurrentSlide(e.to + 1);
  };

  el.addEventListener("slid.bs.carousel", handleSlide);

  return () => {
    el.removeEventListener("slid.bs.carousel", handleSlide);
  };
}, []);

const [currentPage, setCurrentPage] = useState(1);

const itemsPerPage = 10;
const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;

const currentItems = data?.documents?.slice(indexOfFirstItem, indexOfLastItem);

const totalPages = Math.ceil((data?.documents?.length || 0) / itemsPerPage);




  const handleChange = (event:any, value:any) => {
    setCurrentPage(value);
  };

  if (!data || !data.documents?.length) return null;

 // const doucment = chunkArray(data?.documents || [], 1);

  //console.log(data)
  return (
    <div id="section-media-letter">
      <Breadcrumb/>
      <div id="section" className="media ">
        <div className="container ">
          <div
            className="section-title  text-center mx-auto mb-4 wow fadeInUp clearfix"
            data-wow-delay="0.1s"
          >
            <h2 className="mb-4">
            {data?.title} <span className="text-primary">{data?.subtitle}</span>
              {/* <TypedText
                index={1}
                text={`<span style="color:#000">${data?.title}</span> <span style="color:#2aa488">${data?.subtitle}</span> `}
                delay={100}
                cursor="|"
              />{" "} */}
            </h2>
            <p
              className="mx-auto"
              dangerouslySetInnerHTML={{
                __html: data?.description || "",
              }}
            />
          </div>

          <div className="media-letter">
            <div className="row my-3">
              <div className="col-12">
                <h5>
                  {data?.lettertext} <span>({data?.documents.length})</span>
                </h5>
              </div>
            </div>
            <div
             
              className="row"
            
            >
              <div className="col-sm-12"  data-bs-interval="10000">
            
                 
                      {currentItems &&
                        currentItems.map((slide: any, i: any) => (
                          <div
                            className="media-item border-bottom py-3"
                            key={i}
                          >
                            <div className="row align-items-center">
                              <div className="col-2 col-md-1 col-gl-1 text-center mb-2 mb-md-0">
                                <img
                                  src={slide.iconImg}
                                  alt={slide.iconImg}
                                  width="36"
                                />
                              </div>
                              <div
                                className="col-10 col-lg-8 col-md-8 mb-2 mb-md-0 newletter-des"
                                dangerouslySetInnerHTML={{
                                  __html: slide?.description || "",
                                }}
                              />
                              <div className="col-12 col-lg-3 col-md-3 d-flex justify-content-center">
                                <div className="col-6 col-sm-5 col-md-12 col-lg-9 col-xl-8 col-xxl-7">
                                  <a
                                    href={slide.fileUrl}   rel="noreferrer"
                                    target="_blank"
                                    className="btn btn-success rounded-pill px-4 w-100 w-md-auto"
                                  >
                                    {data?.downloadButton}{" "}
                                    <i className={slide.iconClass}></i>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
               
            
            
            </div>
              <div className="col-sm-12">
                <div className="d-flex justify-content-center mt-4">
                   <Pagination
                                          count={totalPages}
                                          page={currentPage}
                                          onChange={handleChange}
                                          color="secondary"
                                      />
                  <nav className="d-none">
                    <ul className="pagination">

                      {/* Previous */}
                      <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                        <button
                          className="page-link"
                          onClick={() => setCurrentPage(currentPage - 1)}
                        >
                          Previous
                        </button>
                      </li>

                      {/* Page Numbers */}
                      {[...Array(totalPages)].map((_, index) => (
                        <li
                          key={index}
                          className={`page-item  ${
                            currentPage === index + 1 ? "active" : ""
                          }`}
                        >
                          <button
                            className="page-link"
                            onClick={() => setCurrentPage(index + 1)}
                          >
                            {index + 1}
                          </button>
                        </li>
                      ))}

                      {/* Next */}
                      <li
                        className={`page-item ${
                          currentPage === totalPages ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => setCurrentPage(currentPage + 1)}
                        >
                          Next
                        </button>
                      </li>

                    </ul>
                  </nav>
                </div>
                
              </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsletterAbout;
